import React, { Component } from 'react'
import formatMoney from '../../helpers/format-money/'
import formatYears from '../../helpers/format-years/'

export default class Results extends Component {
    renderResults = (credits, disabledFlag) => {
        return credits.map((credit, i) => (
            <Result
                key={credit.id}
                credit={credit}
                disabledFlag={disabledFlag}
                handlePick={this.props.handlePick}
                pickedCredit={this.props.pickedCredit}
            />
        ))
    }

    renderNewResults = (credits, disabledFlag) => {
        // console.log('credits renderNewResults = ', credits);
        return (
          credits.map((credit, i) =>
            <NewResult
              key={credit.id}
              credit={credit}
              disabledFlag={disabledFlag}
              handlePick={this.props.handlePick}
              pickedCredit={this.props.pickedCredit}
            />
          )
        )
    };

    render() {
        const { credits } = this.props;
        const { emoji } = this.props;

        console.log('credits = ',emoji);
        console.log('emoji = ',emoji);
        return (
            <React.Fragment>
                {credits.best.length ? (
                    <React.Fragment>
                        {credits.other.length ? (
                        <React.Fragment>
                        </React.Fragment>
                        ) : (
                            <div className="mortgage-results">
                                {this.renderNewResults(credits.newBest)}
                            </div>
                        )}
                    </React.Fragment>
                    ) : (
                        <React.Fragment>
                            <div className="mortgage-results mortgage-results--best">
                                <div className="message-card">
                                <div className="message-card__item">Не удалось подобрать кредит по заданным параметрам.
                                {!!emoji ? <img className="message-card__icon" src={emoji} alt=''/> : null}

                                </div>
                                <div className="message-card__item">Попробуйте увеличить первоначальный взнос или срок кредита.</div>
                                </div>
                            </div>
                        </React.Fragment>
                    )
                }
            </React.Fragment>
        )
    }
}

class Result extends Component {
    constructor(props) {
        super(props)

        this.state = {
            imageState: true,
        }
    }

    handleImageError = () => {
        this.setState({
            imageState: false,
        })
    }

    handlePick = credit => this.props.handlePick(credit)

    render() {
        const { credit, disabledFlag, /*handlePick,*/ pickedCredit } = this.props
        const { imageState } = this.state

        return (
            <div
                className={
                    'mortgage-result' +
                    (disabledFlag ? ' mortgage-result--disabled' : '') +
                    (pickedCredit === credit ? ' mortgage-result--picked' : '')
                }
                /*onClick={disabledFlag ? () => { return } : this.handlePick.bind(this, credit)}*/
            >
                <div className="mortgage-result__wrapper">
                    <div className="mortgage-result__items">
                        <div className="mortgage-result__item">
                            {credit.img && imageState && (
                                <div className="mortgage-result__logo">
                                    <img
                                        src={credit.img}
                                        alt={credit.title}
                                        onError={this.handleImageError}
                                    />
                                </div>
                            )}
                            <div className="mortgage-result__heading">{credit.title}</div>
                        </div>
                        <div className="mortgage-result__item">
                            <div className="mortgage-result__value">
                                {credit.percent}%
                                {(credit.stateSupport || credit.isSubsidizing) ? <span className={"disclaim-star"}>*</span> : ''}
                            </div>
                        </div>
                        {!disabledFlag && (
                            <div className="mortgage-result__item">
                                <div className="mortgage-result__value">
                                    {formatMoney(true).to(credit.payPerMonth)}
                                </div>
                            </div>
                        )}
                        <div className="mortgage-result__item">
                            <div className="mortgage-result__value">
                                {formatYears(credit.creditLength.max)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


class NewResult extends Component {
    constructor(props){
      super(props);

      this.state = {
        imageState: true,
        showOtherOffer: false,
      }
    };

    handleImageError = () => {
      this.setState({
        imageState: false
      })
    };

    handleToggleShowOffer = () => {
      this.setState(prevState => ({
        showOtherOffer: !prevState.showOtherOffer
      }))
    };

    numDeclination = (number) => {
      let result = '';
      if (typeof (number) !== 'number') {
          return ''
      }
      const mod = number % 10;
      if(number > 9 && number < 21){
        result = `${+number} предложений`

      } else {
          switch (mod) {
            case 1:
                result = `${+number} предложение`
                break;
            case 2:
            case 3:
            case 4:
                result = `${+number} предложения`
                break;
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
            case 0:
                result = `${+number} предложений`
                break;
            default:
                result = 'пусто'
          }
      }

      return result;
    };

    handlePick = credit => this.props.handlePick(credit);

    homeIcon = () => {
      return (
        <div className="table-offer__home-icon">
          <svg width="32" height="31" viewBox="0 0 32 31" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.37 5.35229C16.2707 5.25734 16.1387 5.20435 16.0013 5.20435C15.864 5.20435 15.7319 5.25734 15.6326 5.35229L3.35905 17.0772C3.30693 17.1271 3.26546 17.187 3.23716 17.2533C3.20885 17.3197 3.1943 17.3911 3.19438 17.4632L3.19238 28.4674C3.19238 29.0333 3.41715 29.5759 3.81723 29.976C4.21732 30.3761 4.75995 30.6008 5.32576 30.6008H11.7326C12.0155 30.6008 12.2868 30.4884 12.4868 30.2884C12.6869 30.0884 12.7993 29.817 12.7993 29.5341V20.4673C12.7993 20.3258 12.8554 20.1902 12.9555 20.0901C13.0555 19.9901 13.1911 19.9339 13.3326 19.9339H18.666C18.8075 19.9339 18.9432 19.9901 19.0432 20.0901C19.1432 20.1902 19.1994 20.3258 19.1994 20.4673V29.5341C19.1994 29.817 19.3118 30.0884 19.5118 30.2884C19.7119 30.4884 19.9832 30.6008 20.2661 30.6008H26.6702C27.236 30.6008 27.7787 30.3761 28.1787 29.976C28.5788 29.5759 28.8036 29.0333 28.8036 28.4674V17.4632C28.8037 17.3911 28.7891 17.3197 28.7608 17.2533C28.7325 17.187 28.6911 17.1271 28.6389 17.0772L16.37 5.35229Z" fill="#fff"/>
            <path d="M31.6604 14.877L26.6736 10.1063V2.86678C26.6736 2.58387 26.5612 2.31256 26.3612 2.11251C26.1611 1.91247 25.8898 1.80009 25.6069 1.80009H22.4069C22.124 1.80009 21.8526 1.91247 21.6526 2.11251C21.4526 2.31256 21.3402 2.58387 21.3402 2.86678V5.00016L17.4788 1.30808C17.1174 0.942736 16.5801 0.733398 15.9994 0.733398C15.4207 0.733398 14.8847 0.942736 14.5234 1.30874L0.343056 14.8757C-0.0716195 15.2757 -0.123621 15.9337 0.253721 16.3671C0.348477 16.4764 0.464499 16.5654 0.594727 16.6285C0.724955 16.6916 0.866664 16.7276 1.01123 16.7342C1.1558 16.7408 1.3002 16.7179 1.43564 16.667C1.57109 16.616 1.69474 16.538 1.79909 16.4377L15.6327 3.21878C15.732 3.12384 15.864 3.07084 16.0014 3.07084C16.1387 3.07084 16.2708 3.12384 16.3701 3.21878L30.205 16.4377C30.4088 16.6332 30.6818 16.7398 30.9641 16.7343C31.2464 16.7288 31.515 16.6116 31.7111 16.4084C32.1204 15.9844 32.0864 15.2844 31.6604 14.877Z" fill="#fff"/>
          </svg>
        </div>
      )
    }

    showBtnIcon = (reverse = false) => {
      return (
        <span className={ reverse ? 'table-offer__show-btn-icon reverse' : 'table-offer__show-btn-icon' }>
          <svg width="17" height="10" viewBox="0 0 17 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.374196 0.382399C0.613866 0.137549 0.938885 0 1.27778 0C1.61667 0 1.94169 0.137549 2.18136 0.382399L8.50772 6.84743L14.8341 0.382399C15.0751 0.144488 15.398 0.0128435 15.7331 0.0158193C16.0682 0.018795 16.3887 0.156153 16.6257 0.398309C16.8626 0.640464 16.997 0.968042 17 1.31049C17.0029 1.65294 16.874 1.98285 16.6412 2.22918L9.4113 9.6176C9.17163 9.86245 8.84661 10 8.50772 10C8.16882 10 7.8438 9.86245 7.60413 9.6176L0.374196 2.22918C0.134599 1.98425 0 1.65211 0 1.30579C0 0.959466 0.134599 0.627323 0.374196 0.382399Z" fill="currentColor"/>
          </svg>
        </span>
      )
    }

    render(){
      const { credit, disabledFlag, /*handlePick,*/ pickedCredit } = this.props;
      const { imageState } = this.state;
      const [bestOffer, ...otherOffer ] = credit.spisok;
      const { mortgagePrograms } = bestOffer;

        return (
            <div
            className={
                'mortgage-result' +
                (disabledFlag ? ' mortgage-result--disabled' : '') +
                (pickedCredit === credit ? ' mortgage-result--picked' : '')
            }
            /*onClick={disabledFlag ? () => { return } : this.handlePick.bind(this, credit)}*/
            >
            <div className="mortgage-result__wrapper">
                <div className="mortgage-result__items">
                <div className='table-offer'>
					<div class="table-offer__heading">
						<div class="table-offer__heading-info">
							<div className='table-offer__logo-box'>
							{(credit.image && imageState) && (
								<div className="mortgage-result__logo" style={{backgroundColor: credit.backgroundColor ? credit.backgroundColor : '#999999'}}>
								<img src={credit.imageWhite ? credit.imageWhite : credit.image} alt={credit.name} onError={this.handleImageError}/>
								</div>
							)}
							</div>
							<div class="table-offer__heading-about">
                                <div className="mortgage-result__name">{credit.name}</div>
                                {mortgagePrograms?.length ? (
                                <div className="mortgage-result__heading mortgage-result__mortgage-programs">
                                {mortgagePrograms.map((item, i)=>{
                                    return (<span key={i}>{item.name}</span>)
                                })}
                                </div>
                                ) : <div className="mortgage-result__heading mortgage-result__mortgage-programs"><span>Стандартная ипотека</span></div>}

							</div>
						</div>
						<div class="table-offer__heading-order">
							<button class="button-primary button-primary_border-orange" data-bs-toggle="null" data-bs-target="null">
								<span class="button-primary__text pointer-events-none">
									Выбрать
								</span>
							</button>
						</div>
					</div>

                    <div className='table-offer__text-info'>
                        {/* <div className='table-offer__top-info'> */}
                            {/* <div className='table-offer__logo-mobile-box'>
                            {(credit.image && imageState) && (
                                <div className="mortgage-result__logo" style={{backgroundColor: credit.backgroundColor ? credit.backgroundColor : '#999999'}}>
                                <img src={credit.imageWhite ? credit.imageWhite : credit.image} alt={credit.name} onError={this.handleImageError}/>
                                </div>
                            )}
                            </div> */}
                            {/* <div className='table-offer__logo-name-mobile-box'> */}
								{/* <div className="mortgage-result__item table-offer__col table-offer__col--mobile">
									<div className="mortgage-result__title">Ставка</div>
									<div className="mortgage-result__value">От {bestOffer.percent} %</div>
								</div> */}
                            {/* </div> */}
                        {/* </div> */}
                        <div className='table-offer__row'>
                            {!disabledFlag && (
                            <div className="mortgage-result__item table-offer__col table-offer__col--1">
                                <div className="mortgage-result__title">Ежемесячный платеж</div>
                                <div className="mortgage-result__value">От {formatMoney(true).to(bestOffer.payPerMonth)}</div>
                            </div>
                            )}
                            <div className="mortgage-result__item table-offer__col table-offer__col--2">
                            {/* <div className="mortgage-result__title">Ставка {bestOffer.stateSupport ? <span className={"disclaim-star"}>*</span> : ''}</div> */}
                            <div className="mortgage-result__title">Ставка</div>
                            <div className="mortgage-result__value">От {bestOffer.percent} %</div>
                            </div>
                            <div className="mortgage-result__item table-offer__col table-offer__col--3">
                            <div className="mortgage-result__title">Первый взнос</div>
                            <div className="mortgage-result__value">От {bestOffer.minFirstFeePercent} %</div>
                            </div>
                            <div className="mortgage-result__item table-offer__col table-offer__col--4">
                            <div className="mortgage-result__title">Срок</div>
                            <div className="mortgage-result__value">До {formatYears(bestOffer.creditLength.max)}</div>
                            </div>
                            {!!otherOffer.length && (
                            <div className="mortgage-result__item table-offer__col table-offer__col--5">
                                <div className="mortgage-result__title">&nbsp;</div>
                                <div className="mortgage-result__value">
                                {/* <span className="table-offer__show-btn" onClick={this.handleToggleShowOffer}>Еще {otherOffer.length} предложения{this.showBtnIcon(this.state.showOtherOffer)}</span> */}
                                <span className="table-offer__show-btn" onClick={this.handleToggleShowOffer}>Еще {this.numDeclination(otherOffer.length)}{this.showBtnIcon(this.state.showOtherOffer)}</span>
                                </div>
                            </div>
                            )}
                        </div>
                    </div>
                    {bestOffer.disclaimer ? (<div className='table-offer__disclaimer'>
                    {bestOffer.disclaimer}
                    </div>) : null}
                </div>
                </div>


                {this.state.showOtherOffer ? <div className='all-offer' >
                {otherOffer.length ? otherOffer.map((offerItem, i) => {

                    return (
                    <div className='table-offer' key={offerItem.percent}>
                        <div className='table-offer__logo-box'>
                            {this.homeIcon()}
                        </div>
                        <div className='table-offer__text-info'>
                            <div className='table-offer__row'>
                            <div className="mortgage-result__item table-offer__col table-offer__col--1">
                                <div className="mortgage-result__title">Ежемесячный платеж</div>
                                <div className="mortgage-result__value">От {formatMoney(true).to(offerItem.payPerMonth)}</div>
                            </div>
                            <div className="mortgage-result__item table-offer__col table-offer__col--2">
                                {/* <div className="mortgage-result__title">Ставка {offerItem.stateSupport ? <span className={"disclaim-star"}>*</span> : ''}</div> */}
                                <div className="mortgage-result__title">Ставка</div>
                                <div className="mortgage-result__value">От {offerItem.percent} %</div>
                            </div>
                            <div className="mortgage-result__item table-offer__col table-offer__col--3">
                                <div className="mortgage-result__title">Первый взнос</div>
                                <div className="mortgage-result__value">От {offerItem.minFirstFeePercent} %</div>
                            </div>
                            <div className="mortgage-result__item table-offer__col table-offer__col--4">
                                <div className="mortgage-result__title">Срок</div>
                                <div className="mortgage-result__value">До {formatYears(offerItem.creditLength.max)}</div>
                            </div>
                            <div className="mortgage-result__item table-offer__col table-offer__col--5">
                                <div className="mortgage-result__title">Программа</div>
                                <div className="mortgage-result__value">
                                {offerItem.mortgagePrograms.map((item, i)=>{
                                    return (<span key={i}>{item.name}</span>)
                                })}
                                </div>
                            </div>
                            </div>
                        </div>
                        {offerItem.disclaimer ? (<div className='table-offer__disclaimer'>
                        {offerItem.disclaimer}
                        </div>) : null}
                    </div>
                    )
                }) : null}

                </div> : null}

            </div>
            </div>
        )
    }
};

// WEBPACK FOOTER //
// ./src/components/results/index.js
